import React, { useContext } from "react";
import { useGetUserDocuments } from "../../api/user";
import { Loader, Center, Text, Anchor } from "@mantine/core";
import dayjs from "dayjs";
import { IconTrash } from "@tabler/icons-react";
import { TableActions, TableAction, actionsColumn } from "../TableActions";
import { DataTable } from "../DataTable";
import useDeleteDocumentModal from "./DeleteDocumentModal";
import { AuthContext } from "../../services/context";
import { isCurrentEventAdmin } from "../../services/userConfig";

function UserDocuments({ userId, eventId }) {
  const { data, isPending } = useGetUserDocuments({ userId, eventId });
  const openDeleteModal = useDeleteDocumentModal();
  const { user: currentUser } = useContext(AuthContext);

  const isAdmin = isCurrentEventAdmin(currentUser);

  if (eventId && isPending) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  if (!data || data?.data?.length === 0) {
    return (
      <Center>
        <Text>No documents available.</Text>
      </Center>
    );
  }

  return (
    <DataTable
      records={data.data}
      style={{ marginTop: 16 }}
      columns={[
        {
          accessor: "fileName",
          title: "Document Name",
        },
        {
          accessor: "createdAt",
          title: "Date",
          render: (row) => dayjs(row.createdAt).format("DD.MM.YYYY"),
        },
        actionsColumn(
          (row) => (
            <TableActions>
              <Anchor
                href={row.fileKey}
                target="_blank"
                rel="noopener noreferrer"
                style={{ whiteSpace: "nowrap", flexShrink: 0 }}
              >
                Download / View
              </Anchor>
              {isAdmin && (
                <TableAction
                  label="Delete"
                  icon={IconTrash}
                  color="red"
                  onClick={() => openDeleteModal(row)}
                />
              )}
            </TableActions>
          ),
          { title: "Actions" }
        ),
      ]}
      fetching={isPending}
    />
  );
}

export default UserDocuments;
